import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import images from '../constants/images'; // Make sure to add a 404 image

const NotFound = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow text-center px-4 py-8 md:py-16">
        <div className="max-w-3xl mx-auto">
          <div className="animate-float">
            <img 
              src={images.errorimage} // Replace with your 404 illustration
              alt="404 illustration" 
              className="w-full max-w-md mx-auto mb-8"
            />
          </div>
          
          <h1 className="text-4xl md:text-6xl font-bold mb-4 animate-fade-in-up">
            Oops! Page Not Found
          </h1>
          <p className="text-lg md:text-xl text-gray-600 mb-8 animate-fade-in-up delay-100">
            The page you're looking for might have been removed, had its name changed, 
            or is temporarily unavailable.
          </p>
          
          <Link 
            to="/" 
            className="inline-block bg-blue-600 text-white px-8 py-3 rounded-lg 
                      hover:bg-blue-700 transition-all duration-300 transform hover:scale-105
                      animate-fade-in-up delay-200"
          >
            Return to Homepage
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;